import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NowWidgetsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"now_widgets"}/>
}
